<template>
  <Hero :title="data?.title" :narrow="true"/>
  <main class="main maxw--body grid--third-twos block gap--double">
    <div>
      <nuxt-img v-if="data.image?.data" provider="strapi" :src="getStrapiImageLocation(data.image)" class="fit mb-2"></nuxt-img>
      <div class="card">
        <h5 class="mb-1">Contact</h5>
        <a :href="`mailto:${data?.contact_email}`" class="link--flat">{{ data?.contact_email }}</a>
      </div>
    </div>
    <div v-html="$md.render(data?.text || '')" class="rendered mt-0"></div>
  </main>
</template>

<script lang="ts" setup>
import Committee from '~/typings/committee';

const route = useRoute();
const { findOne } = useStrapi();

const { data, pending } = await useAsyncData(
  'eventpage',
  () => findOne<Committee>('slugify/slugs/committee/' + route.params.slug, { populate: 'image' }),
  {
    transform: flattenStrapiObject
  }
);

if (!data.value && !pending.value) {
  throw createError({ statusCode: 404, statusMessage: 'Commissie niet gevonden' });
}

useHead({
  title: `Album: ${data.value?.title || ''}`
});

useHead({
  title: data.value?.title
});
</script>
